<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备型号管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAdd">新增</button>
        </div>
        <div class="searchForm1">
          <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchData"></searchForm> -->
          <el-form ref="searchForm" class="uLabelDcontent" :model="searchParams">
            <el-form-item label="厂家名称">
              <el-select
                :popper-append-to-body="false"
                placeholder="请选择设备厂家"
                value
                v-model="searchParams.dicType"
              >
                <el-option
                  v-for="item in factoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备型号">
              <el-input placeholder="请输入设备型号名称" v-model="searchParams.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/dictionaryData/queryList"
            :parent="self"
            :config="config"
            :other="other"
            ref="deviceType"
          >
            <template slot="last">
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.row)"
                  >编辑</el-link>
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteData(scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
      </el-tab-pane>
    </el-tabs>
    <!-- 弹框 -->
    <el-dialog
      class="editDialog"
      :visible.sync="formVisible"
      :title="title"
      :close-on-click-modal="false"
    >
      <!-- <searchForm :items="items"></searchForm> -->
      <el-form ref="modelForm" :model="modelForm" :rules="rules">
        <el-form-item prop="dicTypeId" label="厂家名称">
          <el-select
            :popper-append-to-body="false"
            placeholder="请选择设备厂家"
            value
            v-model="modelForm.dicTypeId"
            @change="idToName"
          >
            <el-option
              v-for="item in factoryList"
              :label="item.name"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="设备型号">
          <el-input placeholder="请输入设备型号" v-model="modelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input placeholder="请输入设备描述" v-model="modelForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="formVisible = false">取 消</el-button>
        <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      rules: {
        dicTypeName: [
          { required: true, message: "请输入生产厂家", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入设备型号", trigger: "blur" }]
      },
      factoryList: [],
      paramsList: [],
      additionSettings: [],
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      editDialogVisible: false,
      settingFormVisible: false,
      formVisible: false,
      hasBasicInfo: false,
      title: "",
      showTable: true,
      other: {
        dicKey: "FACTORY"
      },
      optiontype: [],
      searchParams: {
        dicType: null,
        name: "",
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      modelForm: {
        id: null,
        dicTypeId: null,
        dicTypeName: "",
        name: "",
        remark: "",
        selParam: "",
        basicParam: []
      },
      status: ""
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "设备型号"
        },
        {
          prop: "dicTypeName",
          label: "设备厂家"
        },
        {
          prop: "remark",
          label: "备注"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //获取厂家名称
    idToName(val) {
      let temp = this.factoryList.find(it => it.id === val)
      //console.log(temp,"temp")
      if(temp) {
        this.modelForm.dicTypeName = temp.name;
      }
    },
    //初始化一些基本数据
    initFactoryList() {
      this.$axios
        .get(process.env.API_HOST + "operation/dictionaryType/queryList", {
          params: {
            key: "FACTORY",
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.factoryList = res.data.data.list || [];
          //console.log(this.factoryList);
        });
    },
    //初始化参数列表
    initParamsList() {
      let params = {
        dicKey: "PUMP",
        pageSize: 99,
        pageNum: 1
      };
      this.$axiosget("operation/dictionaryData/queryList", {
        params: params
      }).then(res => {
        if (res.data.status === "10000") {
          this.paramsList = res.data.data.list;
        } else {
          this.paramsList = [];
        }
      });
    },
    //搜索
    subSeefrom() {
      this.other = this.searchParams;
      this.other.dicKey = "FACTORY";
      this.$refs.deviceType.pageToOne();
      this.$nextTick(this.$refs.deviceType.getData);
    },
    reset() {
      this.searchParams = {};
    },
    //新增
    toAdd() {
      this.title = "新增设备型号";
      this.formVisible = true;
      this.hasBasicInfo = false;
      this.modelForm = {
        dicTypeName: "",
        name: "",
        remark: "",
        selParam: "",
      };
      if (this.$refs["modelForm"])
        this.$refs["modelForm"].resetFields();
      this.status = 1;
    },
    //修改
    toEdit(row) {
      //console.log(row)
      this.status = 2;
      this.title = "修改设备型号";
      this.formVisible = true;
      this.modelForm.dicTypeId = row.dicTypeId;
      this.modelForm.dicTypeName = row.dicTypeName;
      this.modelForm.name = row.name;
      this.modelForm.remark = row.remark;
      this.modelForm.id = row.id;
      //console.log(this.modelForm,"modelForm")
    },
    //删除
    deleteData(row) {
      this.$confirm("确定删除该条数据?", "删除操作", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/dictionaryData/deleteById", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message({
            showClose: true,
            message:
              res.data.status === "10000"
                ? "删除成功！"
                : res.data.message || "删除失败！)",
            type: res.data.status === "10000" ? "success" : "warning"
          });
          if (res.data.status === "10000") this.subSeefrom();
        });
      }).catch(()=>{

      })
    },
    //确认
    submitForm() {
      this.$refs.modelForm.validate(valid => {
        if (valid) {
          if (this.status === 1) {
            this.$axiospost("operation/dictionaryData/add", {
              // params: {
                dicTypeId: this.modelForm.dicTypeId,
                name: this.modelForm.name,
                remark: this.modelForm.remark,
                // basicParam: JSON.stringify(this.modelForm.basicParam)
              // }
            }).then(res => {

              if(res.data.status === "-10000") {
                this.$message.warning("信息不完整或值重复！");
              } else {
                this.formVisible = false;
              this.subSeefrom();
              this.$message.success("新增成功！");
              }
            });
          } else if (this.status === 2) {
            this.$axiospost("operation/dictionaryData/update", {
              // params: {
                id: this.modelForm.id,
                dicTypeId: this.modelForm.dicTypeId,
                name: this.modelForm.name,
                remark: this.modelForm.remark,
                // basicParam: JSON.stringify(this.modelForm.basicParam)
              // }
            }).then(res => {
              this.formVisible = false;
              this.subSeefrom();
              this.$message.success("修改成功！");
            });
          }
        }
      });
    },
    // 查询基本参数
    // queryParams(row) {
    //   this.$axiosget("operation/pump_type/query_by_mode", {
    //     params: {
    //       id: row.id
    //     }
    //   }).then(res => {
    //     if (res.data.status === "10000") {
    //       let data = res.data.data;
    //       //console.log(data,"data")
    //       this.modelForm = {
    //         id: row.id,
    //         dicTypeId: row.dicTypeId,
    //         dicTypeName: row.dicTypeName,
    //         name: row.name,
    //         remark: row.remark,
    //         basicParam: data ? JSON.parse(data.basicParam) : []
    //       };
    //       this.hasBasicInfo = this.modelForm.basicParam.length !== 0;
    //       //console.log(this.hasBasicInfo,"hasBasicInfo")
    //     }
    //   });
    //   return null;
    // },
    newParam() {
      let key = this.modelForm.selParam;
      if (!key) return;
      let params = this.modelForm.basicParam;
      let temp = params.find(it => it.key === key);
      if (temp) {
        this.$message({
          showClose: true,
          message: "不能添加重复信息",
          type: "warning"
        });
        return;
      }
      let t = this.paramsList.find(it => it.value === key);
      params.push({
        key: key,
        name: t.name,
        value: ""
      });
      this.$refs["selParam"].clearValidate();
    },
    toSettingParams() {
      this.settingFormVisible = true;
      this.additionSettings = [];
    },
    newSetting() {
      this.additionSettings.push({
        name: "",
        value: ""
      });
    },
    saveSetting() {
      let addition = this.additionSettings;
      if (!addition || addition.length === 0) {
        this.$message({
          showClose: true,
          message: "请添加基本信息参数配置！",
          type: "warning"
        });
      }
      let flag = 0;
      addition.forEach(it => {
        if (!it.name || !it.value) {
          this.$message({
            showClose: true,
            message: "参数配置信息填写有误！",
            type: "warning"
          });
          flag = 1;
          return false;
        }
      });
      if (1 === flag) return;
      //全部检验完再保存
      addition.forEach(item => {
        let params = {
          dicTypeKey: "PUMP",
          name: item.name,
          value: item.value
        };
        this.$axiospost("operation/dictionaryData/add", params).then(res => {
          this.$message({
            showClose: true,
            message:
              res.data.status === "10000"
                ? "保存成功！"
                : res.data.message || "系统异常！",
            type: res.data.status === "10000" ? "success" : "warning"
          });
          this.initParamsList();
          this.additionSettings = [];
          this.settingFormVisible = false;
        });
      });
    }
  },
  mounted() {
    this.initFactoryList();
    this.initParamsList();
  }
};
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.editDialog {
  .params-data {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    // i.del {
    //   font-size: 20px;
    //   color: #bc3b3a;
    //   margin: 0 6px;
    //   vertical-align: middle;
    // }
    .el-input {
      // width: 180px !important;
      margin: 12px 8px 4px 0;
    }
    .el-form-item {
      // width: 180px !important;
      margin: 4px 8px;
      display: inline-block;
    }
  }
  .setting-line {
    text-align: center;
  }
  .btn-line {
    margin-top: 20px;
    padding-left: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deviceType.vue